export default __webpack_public_path__ + "static/media/checkbox-unchecked-tata-neu@2x.af9ec2ae.png";